import { create } from 'zustand'
import {
   NUMBER_PRICE_PER_MONTH,
   ORG,
   SAMPLE_LEAD,
   VOICES,
} from '@forwardflow/features/campaign-flow/data/mock'
import {
   IOrgContext,
   ISampleLead,
   IVoiceOption,
} from '@forwardflow/features/campaign-flow/interfaces/campaign-flow.types'

/**
 * Reference data the screens show, filled by the service (demo or live):
 * the voices on offer, the organization the assistant speaks for, and the
 * sample lead the test phone plays. Starts as the demo so the preview needs
 * nothing loaded.
 */
interface IFlowDataState {
   voices: IVoiceOption[]
   org: IOrgContext
   lead: ISampleLead
   /** Monthly price of one new number. */
   numberPrice: number
   setVoices: (voices: IVoiceOption[]) => void
   setContext: (c: IFlowContext) => void
}

export interface IFlowContext {
   org: IOrgContext
   lead: ISampleLead
   numberPrice: number
}

export const useFlowData = create<IFlowDataState>((set) => ({
   voices: VOICES,
   org: ORG,
   lead: SAMPLE_LEAD,
   numberPrice: NUMBER_PRICE_PER_MONTH,
   setVoices: (voices) => set({ voices: voices.length ? voices : VOICES }),
   setContext: (c) => set(c),
}))
